module.exports = __webpack_public_path__ + "img/walletBox22.6506cdfd.png";